import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import sirionPhoto from '../../assets/img/sirion.png'
export default function HeadLine(){
  const [greeting,setGreeting] = useState("Hi, I'm");
  useEffect(()=>{
    const hour = new Date().getHours();
    let greet = "Good Morning, I'm"
    if(hour > 17){
      greet = "Good Evening, I'm"
    }else if(hour > 11){
      greet = "Good Afternoon, I'm"
    }

    setGreeting(greet)
  },[])
  return (
    <Container>
      <div className="container">
      <GreetingContainer>
        <GreetingHeadline>{greeting}</GreetingHeadline>
        <DisplayName>Sirion Vittayakorn</DisplayName>
        <Paragraph>My research interests lie at the intersection of computer vision and machine learning.
          My works focus on using large-scale data from the Internet to develope methods that combine
          information from both the visual and textual sources effectively
          for many real-world applications related to visual attributes and visual styles.</Paragraph>
      </GreetingContainer>
      <DisplayImage className="sirion-photo" src={sirionPhoto} alt="Sirion Vittayakorn" />
      </div>

    </Container>
  );
}

const Container = styled.section`
  height: 500px;
  overflow: hidden;
   & > .container{
    position: relative;
    display: grid;
    grid-template-columns: 2fr 1fr;
    box-sizing: border-box;
   }
`
const DisplayImage = styled.img`
  height: 500px;
  bottom: -20%;
  right: 10%;
  justify-self: center;
  transform: translateY(15%);
  z-index: -1;
`
const GreetingContainer = styled.div`
  margin-bottom: 32px;
  align-self: flex-end;
  height: fit-content;
  border-radius: 24px;
`
const GreetingHeadline = styled.h2`
  color: var(--assent-color);
  font-weight: 400;
  font-family: 'Concert One', cursive;
  text-align: right;
`
const DisplayName = styled.h1`
  color: var(--assent-color);
  font-weight: 400;
  font-family: 'Concert One', cursive;
  text-align: right;
`
const Paragraph = styled.p`
  font-size: 1.3em;
  color: var(--text-color);
  text-align: right;
`